export default function test(str) {
    if (str) if (str.length < 1) return "One characters minimum";
    return true;
}